import React from 'react'
import { Skeleton, Box, Grid, useTheme, Divider } from '@mui/material'
import './loading.css'
import { gridStyles } from '../Deals/style'

const rowStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center', // ensure child stretches
  justifyContent: 'space-between',
  width: '100%',
  height: '100%',
}

const cardSkeletonStyle = bgcolor => ({
  height: '100%', // will inherit Grid item height
  width: '100%',
  borderRadius: '25px',
  bgcolor: bgcolor ?? 'background.section',
})
const DealDetailsLoading = () => {
  const theme = useTheme()

  return (
    <Grid container spacing={0} justifyContent='center' sx={{ ...gridStyles(theme) }}>
      <Grid
        container
        sx={{
          justifyContent: 'center',
          p: 1,
          gap: 0.5,
        }}
      >
        <Grid item xs={12}>
          <Skeleton
            variant='rectangular'
            animation='wave'
            sx={{ ...cardSkeletonStyle('background.default'), height: 30, mb: 2 }}
          />
        </Grid>
        <Grid item xs={12}>
          <Box sx={rowStyle}>
            {[1, 2, 3].map(i => (
              <Grid
                key={i}
                item
                xs={12}
                sm={3.9}
                md={3.9}
                lg={3.9}
                xl={3.9}
                p={4}
                mb={1}
                sx={{
                  bgcolor: theme.palette.background.section,
                  borderRadius: '25px',
                  minHeight: 463, // match realistic DealInfoCard height
                  height: '100%',
                  width: '100%',
                }}
              >
                <Skeleton variant='rectangular' animation='wave' sx={{ bgcolor: 'background.section' }} />
              </Grid>
            ))}
          </Box>
          <Divider orientation='horizontal' flexItem />
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ ...rowStyle, py: 0.5, gap: 2 }}>
            <Skeleton
              variant='rectangular'
              animation='wave'
              sx={{ ...cardSkeletonStyle('background.default'), mt: 2, height: 56, width: '20%' }}
            />
            <Skeleton
              variant='rectangular'
              animation='wave'
              sx={{ ...cardSkeletonStyle('background.default'), mt: 2, height: 56, width: '20%' }}
            />
            <Skeleton
              variant='rectangular'
              animation='wave'
              sx={{ ...cardSkeletonStyle('background.default'), mt: 2, height: 56, width: '20%' }}
            />
          </Box>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default DealDetailsLoading
